export const ErrorType = {
    MOBILE_NOT_VERIFIED: 36,
    EMAIL_AND_MOBILE_NOT_VERIFIED: 2016,
    CAPTCHA_REQUIRED: 2120,
    JUST_VERIFIED: -1,
    WRONG_AUTH_TOKEN: 37,
    INVALID_CAPTCHA: 2001,
    CLIENT_NOT_FOUND: 22,
    WRONG_PASSWORD: 6,
    INACTIVE_ACCOUNT: 10006,
    AGENT_FIRST_LOGIN: 2172,
    TWO_FACTOR_AUTH: 2175,
    UNVERIFIED_WITHDRAWAL: 2041,
    UNVERIFIED_DEPOSIT: 2042,
    UNVERIFIED_PLAYER_DEPOSIT_LIMIT: 2090,
    CPF_NOT_FILL: 6895,
    Invalid_Cupis_V2_Verification: 2246,
    NotTrustedDevice: 2254,
    NotEnoughfFounds: 2067,
    FIREBASE_USER_NOT_REGISTERED: 3
};


Object.freeze(ErrorType)



export default ErrorType;